import React, { FunctionComponent, useMemo } from "react";
import { Trans } from "@lingui/macro";
import { EnteredTaxCodeRow } from "./EnteredTaxCodeRow";
import { pipe } from "fp-ts/lib/function";
import { useAangifte } from "components/aangifte/AangifteProvider";
import { rubriekenFp, rubriekFp } from "domain/rubriek";
import { array } from "fp-ts";
import { noQuickEntryCodes } from "./useQuickEntryRubriek";

export interface Props {
  taxCodesOrderedByEntry: Set<string>;
}

export const EnteredTaxCodesTable: FunctionComponent<Props> = ({ taxCodesOrderedByEntry }) => {
  const { aangifte } = useAangifte();

  const orderedKeys = useMemo(() => {
    return pipe(
      aangifte.rubrieken,
      rubriekenFp.filter(rubriekFp.hasValue),
      rubriekenFp.filter((r) => !rubriekFp.isInternalRubriek(r)),
      rubriekenFp.keys,
      (keys) => new Set([...taxCodesOrderedByEntry, ...keys]),
      (combined) => [...combined],
      array.filter((code) => !noQuickEntryCodes.includes(code))
    );
  }, [aangifte.rubrieken, taxCodesOrderedByEntry]);

  return useMemo(() => {
    return (
      <div id="codesok">
        <div className="codesrow" id="rijhoofd" style={{"paddingLeft": "4px"}}>
          <div className="colcode">
            <h2>
              <Trans>Code</Trans>
            </h2>
          </div>
          <div className="colamount">
            <h2>
              <Trans>Bedrag</Trans>
            </h2>
          </div>
          <div className="coldescr">
            <h2>
              <Trans>Omschrijving</Trans>
            </h2>
          </div>
        </div>
        {orderedKeys.map((code) => (
          <EnteredTaxCodeRow key={code} code={code} />
        ))}
      </div>
    );
  }, [orderedKeys]);
};

EnteredTaxCodesTable.displayName = "EnteredTaxCodesTable";
